import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';
import { NTAKAccountSettings } from '../../models/serializable/ntak-account-settings.js';
import { NTAKProgramSettings } from '../../models/serializable/ntak-program-settings.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { isSameData } from '../../models/dto/data-model-utils.js';

/**
 * @deprecated Use {@link NTAKEventSettingsComponent} instead.
 */
export class NTAKSettingsComponent extends Component {
  static readonly TYPE_ID: string = '47b820e800554d118ea846292470687e';

  private constructor(
    public readonly accountSettings: NTAKAccountSettings,
    public readonly programSettings: NTAKProgramSettings,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return NTAKSettingsComponent.TYPE_ID;
  }

  static create(args: {
    accountSettings: NTAKAccountSettings,
    programSettings: NTAKProgramSettings,
  }): NTAKSettingsComponent {
    return new NTAKSettingsComponent(
        args.accountSettings,
        args.programSettings,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): NTAKSettingsComponent {
    return new NTAKSettingsComponent(
        context.fromData<NTAKAccountSettings>(MapUtils.get<SerializedData>(map, 'accountSettings')),
        context.fromData<NTAKProgramSettings>(MapUtils.get<SerializedData>(map, 'programSettings')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      accountSettings: context.toData(this.accountSettings),
      programSettings: context.toData(this.programSettings),
    };
  }

  clone(): this {
    return new NTAKSettingsComponent(
        this.accountSettings.clone(),
        this.programSettings.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.accountSettings, this.accountSettings) &&
        isSameData(other.programSettings, this.programSettings);
  }
}

export class NTAKSettingsComponentBuilder extends DataModelBuilder<NTAKSettingsComponent> {
  build(
      context: SerializationContext,
      map: SerializedData,
  ): NTAKSettingsComponent {
    return NTAKSettingsComponent.fromMap(context, map);
  }
}
